export const errorCodes = ['404'];